// extracted by mini-css-extract-plugin
module.exports = {"socialBtn":"SocialBtn_socialBtn__mKZ7M"};